
export default {
    async fetch() {
        await this.$store.dispatch('jsonloader/fetchJson', `products.json`)
    },
}
